import styles from './Keyboard.module.scss'
import classNames from "classnames";
import {SyntheticEvent, useEffect, useRef, useState} from "react";
import Icon from "@/components/UI/Icon/Icon";
import Mana from "@/components/Spellify/Mana/Mana";

type Props = {
  onKeyPressed: (key:string, shiftPressed?: boolean) => void
  secondaryMenu?: boolean
  markedGreen?: string[]
  markedRed?: string[]
  hidden?: boolean
  hideOnLargerScreens?: boolean
}

const NUMBER_ROW = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0']
// const NUMBER_ROW_MANA = ['{1}', '{2}', '{3}', '{4}', '{5}', '{6}', '{7}', '{8}', '{9}', '{0}']
// const NUMBER_ROW_ALTERNATE = ['{10}', '{11}', '{12}', '{13}', '{14}', '{15}', '{16}', '{17}', '{18}', '{19}', '{20}']
const MTG_ROW = ['{W}', '{U}', '{B}', '{R}', '{G}', '{WP}', '{UP}', '{BP}', '{RP}', '{GP}']
const MTG_ROW2 = ['{C}', '{T}', '{Q}', '{E}', '+', '-', '*']
// const MTG_ROW3 = ['{WB}', '{UR}', '{BG}', '{RW}', '{GU}','{C}', '{T}', '{Q}', '{E}']
const FIRST_ROW = ['Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P']
const SECOND_ROW = ['A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L']
const THIRD_ROW = ['Z', 'X', 'C', 'V', 'B', 'N', 'M']
const ROWS = [FIRST_ROW, SECOND_ROW, THIRD_ROW]
const ALTERNATE_ROWS = [NUMBER_ROW, MTG_ROW, MTG_ROW2]
// const NUMBER_ROWS = [NUMBER_ROW, NUMBER_ROW_MANA, NUMBER_ROW_ALTERNATE]
const Keyboard = ({onKeyPressed, secondaryMenu, markedGreen=[], markedRed=[], hidden, hideOnLargerScreens}: Props) => {

  const onKeyPressedRef = useRef<(key: string, shiftPressed?: boolean) => void>()

  const [keyboardIndex, setKeyboardIndex] = useState(0)



  useEffect(() => {
    function handleKeyDown(e: KeyboardEvent) {
      const modal = document.getElementById('ch-page-modal')
      if (modal) return

      if (!onKeyPressedRef.current) return;
      if (e.ctrlKey || e.altKey || e.metaKey) return

      if ('vibrate' in navigator)
        navigator.vibrate(50)

      if (
        e.key === 'Backspace'
        || e.key === 'Delete'
        || e.key === 'ArrowLeft'
        || e.key === 'ArrowRight'
        || e.key === 'ArrowUp'
        || e.key === 'ArrowDown'
        || e.key === 'Enter'
        || e.key === 'Tab'
        || e.key === ' '
      ) {
        e.preventDefault()
        return onKeyPressedRef.current(e.key, e.shiftKey)
      }
      if (!e.key.match(/[a-zA-Z]+/) || e.key.length > 1) return

      onKeyPressedRef.current(e.key.toUpperCase())
    }

    document.body.addEventListener('keydown', handleKeyDown)

    return () => {
      document.body.removeEventListener('keydown', handleKeyDown)
    }
  }, []);

  useEffect(() => {
    onKeyPressedRef.current = onKeyPressed
  }, [onKeyPressed]);

  if (hidden) return null

  return (
    <div className={classNames(styles.container, hideOnLargerScreens && styles.hideWhenLarge)}>
      {keyboardIndex === 0 && ROWS.map((row, i) => (
        <div key={i} className={classNames(styles.row, styles[`r${i}`])}>
          {i === ROWS.length-1 && secondaryMenu && 
            <>
              <div className={styles.contextButton} onClick={() => setKeyboardIndex(1)}>123<Mana color="w"/></div>
            </>
          }
          {row.map(letter => (
            <div onClick={() => onKeyPressed(letter)} className={classNames(styles.button, markedRed?.includes(letter) && styles.red, markedGreen?.includes(letter) && styles.green)} key={letter}>{letter}</div>
          ))}
          {i === ROWS.length-1 && <div className={styles.button} onClick={() => onKeyPressed('Backspace')}><Icon icon="backspace"/></div>}
        </div>
      ))}
      {keyboardIndex === 1 &&
        ALTERNATE_ROWS.map((row, i) => (
          <div key={i} className={classNames(styles.row, styles[`r${i}`])}>
            {i === ALTERNATE_ROWS.length-1 && 
              <>
                <div className={styles.contextButton} onClick={() => setKeyboardIndex(0)}>ABC</div>
              </>
            }
            {row.map(letter => (
              <div onClick={() => onKeyPressed(letter)} className={classNames(styles.button, styles.key, markedRed?.includes(letter) && styles.red, markedGreen?.includes(letter) && styles.green)} key={letter}>
                {letter.includes('{') ? <Mana color={letter.replace('{', '').replace('}', '') as any} /> : letter}
              </div>
            ))}
            {i === ALTERNATE_ROWS.length-1 && <div className={styles.button} onClick={() => onKeyPressed('Backspace')}><Icon icon="backspace"/></div>}
          </div>
        ))
      }
    </div>
  )
}

export default Keyboard